jQuery(document).ready(function($) {
    $('body, html').scroll(function() {
        var t = $('body').scrollTop();
        $('body').attr('data-scrolltop', t);
    });
});